export default __webpack_public_path__ + "static/1.1_EN-f6f0d19c16a242d5bb65642ca012cc46.png";